import React from 'react';
import { Link } from 'react-router-dom';

type CardProps = {
    children?: React.ReactNode;
    elevation?: 'flat' | 'sm' | 'md';
    interactive?: boolean;
    radius?: 'lg' | 'xl' | '2xl';
    /* Renders the card as a router link. */
    to?: string;
    className?: string;
} & React.HTMLAttributes<HTMLElement>;

export const Card = React.forwardRef<HTMLElement, CardProps>(function Card(
    { children, elevation = 'sm', interactive = false, radius = 'xl', to, className = '', ...rest },
    ref,
) {
    const cls = [
        'ds-card',
        elevation !== 'sm' ? `ds-card--${elevation}` : '',
        radius !== 'xl' ? `ds-card--r-${radius}` : '',
        interactive || to ? 'ds-card--interactive' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    if (to) {
        return (
            <Link ref={ref as React.Ref<HTMLAnchorElement>} to={to} className={cls} {...rest}>
                {children}
            </Link>
        );
    }
    return (
        <div ref={ref as React.Ref<HTMLDivElement>} className={cls} {...rest}>
            {children}
        </div>
    );
});
